import { MapContainer, TileLayer } from 'react-leaflet';
import Points from './Points';
import { useQuery } from '../CustomHooks/useLocation';
import { toast } from 'react-toastify';
import './MyMap.css';
import { useState } from 'react';
import Admin from './Admin';

const MyMap = () => {
    const [map, setMap] = useState();

    let query = useQuery();

    const [urlZoom, urlLat, urlLng] = [query.get('zoom'), query.get('lat'), query.get('lng')];

    const handleCopyToClipboard = () => {
        const { lat: currLat, lng: currLng } = map.getCenter();
        const currZoom = map.getZoom();
        try {
            navigator.clipboard
                .writeText(`${window.location.href.split('?')[0]}?lat=${currLat}&lng=${currLng}&zoom=${currZoom}`)
                .then(() =>
                    toast.success('Скопировано в буфер обмена!', {
                        autoClose: 1500,
                        type: 'success',
                        toastId: 'copy_to_clipboard',
                    })
                )
                .catch(() =>
                    toast.error('Ошибка при копировании!', {
                        autoClose: 1500,
                        type: 'error',
                        toastId: 'copy_to_clipboard',
                    })
                );
        } catch (error) {
            toast.error('Ошибка при копировании!', {
                autoClose: 1500,
                type: 'error',
                toastId: 'copy_to_clipboard',
            });
        }
    };

    return (
        <>
            <button className='url-btn' onClick={handleCopyToClipboard}>
                {'Скопировать ссылку на локацию :)'}
            </button>
            <MapContainer
                center={[urlLat || 0, urlLng || 0]}
                zoom={urlZoom || 2}
                scrollWheelZoom={true}
                style={{ height: 'calc(100vh - 50px)', width: '100wh' }}
                attributionControl={false}
                ref={setMap}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                />
                <Points
                    isAllUrlParamsDontExist={
                        !query.get('zoom') && !query.get('lat') && !query.get('lng') ? true : false
                    }
                />
            </MapContainer>
            <Admin map={map} />
        </>
    );
};

export default MyMap;
